import { ConnectionNames } from "../../../Contracts";
import { applyRESTQueries } from "../../../Common";
export function applyCasinoQueries(message) {
    return applyRESTQueries(ConnectionNames.casino, message);
}
//# sourceMappingURL=ApplyCasinoQueries.js.map